import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
//import PasswordRegistration from 'pages/Login/PasswordRegistration';
import PasswordRegistrationNew from './PasswordRegistrationNew';

export default function PasswordRegistrationWrapper() {
	const navigate = useNavigate();
	const location = useLocation();

	function navigateToPath(path, state) {
		navigate(path, state);
	}
	// return <PasswordRegistration navigate={navigateToPath} location={location} />;
	return <PasswordRegistrationNew navigate={navigateToPath} location={location} />;
}
